import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import allcadLogo from '../assets/images/allcadLogo.png'
const Footer = () => {
  return (
    <Paper
      component="footer"
      elevation={1}
      sx={{
        bgcolor: 'background.default',
        height: '40.8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 4,
        borderTop: '0.8px solid',
        borderColor: 'divider',
        boxShadow: '0px -1px 3px 0px rgba(0,0,0,0.1), 0px -1px 2px -1px rgba(0,0,0,0.1)',
        // position: 'relative',
        zIndex: 1300,
        borderRadius: 0,
        position: 'fixed',
        bottom: 0,
        width: "100%",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '20px',
          color: '#6a7282',
          whiteSpace: 'nowrap',
        }}
      >
        Ready
      </Typography>

      <Typography
        variant="body2"
        sx={{
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '20px',
          color: '#6a7282',
          whiteSpace: 'nowrap',
        }}
      >
        © 2025 AllCAD Solutions FZC. All rights reserved
      </Typography>

      <Box
        component="img"
        src={allcadLogo}
        alt="AllCAD Logo"
        sx={{
          height: 24,
          width: 'auto',
          objectFit: 'contain',
        }}
      />
    </Paper>
  );            
};

export default Footer;